/* CartIntel UI lifecycle, 2026-09-09. No cart writes; no app overrides. */
(function () {
  'use strict';
  if (window.DionisCartUI) return;
  const tracked = new Map();
  let frame = 0;

  function measure() {
    frame = 0;
    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    document.querySelectorAll('.drawer--container[data-view="cart-drawer"]').forEach(container => {
      container.style.setProperty('--dionis-cart-viewport-height', `${Math.max(1, Math.floor(viewportHeight))}px`);
    });
    for (const [root, entry] of tracked) {
      if (!root.isConnected) {
        entry.observer.disconnect();
        tracked.delete(root);
        continue;
      }
      if (!root.getClientRects().length || root.clientHeight <= 0) continue;
      const summary = root.querySelector('.cart--summary');
      if (!summary) continue;
      if (summary !== entry.summary) {
        if (entry.summary) entry.observer.unobserve(entry.summary);
        entry.summary = summary;
        entry.observer.observe(summary);
      }
      const height = Math.min(root.clientHeight, viewportHeight);
      const reserve = Math.min(160, height * 0.4);
      root.dataset.summaryOverflow = summary.offsetHeight > height - reserve ? 'scroll' : 'fixed-space';
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(measure);
  }
  function discover() {
    if (typeof ResizeObserver === 'function') {
      document.querySelectorAll('cart-element[data-summary-layout="flow"]').forEach(root => {
        if (tracked.has(root)) return;
        const observer = new ResizeObserver(schedule);
        observer.observe(root);
        const summary = root.querySelector('.cart--summary');
        if (summary) observer.observe(summary);
        tracked.set(root, { observer, summary });
      });
    }
    schedule();
  }
  /* Gift box follows the shopper's last explicit choice for the session
     (Baruch, 9/9). Native updates never touch it; app innerHTML rebuilds
     re-render it closed, so the intent lives here and is re-applied. DOM is
     presentation, intent is state (playbook A7). Manual close is honored:
     nothing auto-opens unless the shopper opened it. */
  const giftIntent = Object.create(null);
  document.addEventListener('toggle', function (event) {
    const details = event.target;
    if (!details || !details.matches || !details.matches('cart-element .cart--gift')) return;
    const root = details.closest('cart-element');
    const view = (root && root.dataset.view) || 'drawer';
    const wasOpen = giftIntent[view] === true;
    giftIntent[view] = details.open;
    /* A shopper-initiated open (intent went from not-open to open) reveals
       the field: the drawer's scroll area does not grow into view on its own,
       so the first open landed below the fold. Restores from intent skip this. */
    if (details.open && !wasOpen) {
      const field = details.querySelector('textarea');
      if (!field) return;
      try { field.focus({ preventScroll: true }); } catch (e) { /* focus is best effort */ }
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      field.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    }
  }, true);
  function applyGiftIntent() {
    document.querySelectorAll('cart-element .cart--gift').forEach(function (details) {
      const root = details.closest('cart-element');
      const wanted = giftIntent[(root && root.dataset.view) || 'drawer'];
      if (typeof wanted === 'boolean' && details.open !== wanted) details.open = wanted;
    });
  }
  function rebuilt() {
    discover();
    applyGiftIntent();
  }
  window.addEventListener('theme:cart:updated', rebuilt);
  window.addEventListener('theme:drawer:open', function () { discover(); applyGiftIntent(); });
  window.addEventListener('resize', schedule, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', discover);
  window.addEventListener('pageshow', discover);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', discover, { once: true });
  else discover();
  window.DionisCartUI = Object.freeze({ refresh: discover });
})();

/* Drawer switch guard (Baruch, 2026-09-30). Blockshop 12.2.1's Drawer.open(),
   when a drawer on another side is open (search is "top", the cart is
   "right"), queues the new drawer in pending_open and closes the current one;
   closed() then opens the queued drawer. The theme's add-to-cart flow asks to
   open the cart drawer twice, a moment apart. When the second request arrives
   while search is still closing, open() clears the queue and starts opening
   early; search then finishes closing, marks the drawer closed and removes the
   cart view, so the cart drawer shuts or stays blank. This skips an open
   request that is already queued while the previous drawer closes. Every
   other open, including the queued one that closed() replays, runs as before.
   theme.js is not edited. Remove this block if Blockshop fixes Drawer.open(). */
(function () {
  'use strict';

  customElements.whenDefined('drawer-element').then(function () {
    var D = customElements.get('drawer-element');

    if (!D || !D.prototype || D.prototype.__dionisSwitchGuard) return;

    var open = D.prototype.open;
    if (typeof open !== 'function') return;

    D.prototype.open = function (side, view) {
      var queued = this.pending_open;

      if (
        D.status === 'closing' &&
        queued &&
        queued[0] === side &&
        queued[1] === view
      ) {
        return;
      }

      return open.apply(this, arguments);
    };

    D.prototype.__dionisSwitchGuard = true;
  });
})();